import _ from "lodash";
import React, { useCallback, useEffect, useMemo } from "react";
import { Button } from "reactstrap";
import {
  WHATSAPP_GET_LOADING,
  WHATSAPP_SYNC_LOADING,
} from "../../../../constants/loading.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useMeCore } from "../../../../cores/me";
import {
  SocialProviderId,
  SocialProviderName,
} from "../../../../cores/socialPost/config";
import { useIntl } from "react-intl";
import { SocialProvider } from "../../../../cores/socialPost/interfaces/socialProvider";
import SocialCard from "../SocialCard";
import { WhatsappIcon } from "./WhatsappIcon";
import { useWhatsappCore } from "../../../../cores/whatsapp";

export default function WhatsappBindCard() {
  const intl = useIntl();
  const { get, settings, unbind } = useWhatsappCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { isLoading } = useGlobalCore();

  useEffect(() => {
    get(company!.id);
  }, [company, get]);

  const isActive = useMemo(
    (): boolean => !_.isEmpty(settings),
    [settings]
  );

  const handleBind = useCallback(async () => {
    // @ts-ignore
    const $crisp = window["$crisp"];
    $crisp.push(["do", "chat:open"]);
    $crisp.push(["set", "message:text", ["Hola! me contacto con ustedes porque quiero utilizar Whatsapp"]]);
  }, []);

  const handleUnbind = useCallback(() => {
    unbind(company!.id, () => {
      getMeSocialSettings(company?.id!);
    });
  }, [company, unbind, getMeSocialSettings]);

  const socialProvider = useMemo(
    (): SocialProvider => ({
      id: SocialProviderId.Whatsapp,
      name: SocialProviderName.Whatsapp,
      icon: <WhatsappIcon size="6x" active={isActive} />,
      displayName: settings?.phoneNumber,
    }),
    [settings, isActive]
  );

  return (
    <SocialCard
      social={socialProvider}
      bindLoading={isLoading(WHATSAPP_SYNC_LOADING)}
      getLoading={isLoading(WHATSAPP_GET_LOADING)}
      showSynchronizer={false}
    >
      <div className="w-100 px-2">
        <Button
          className="w-100"
          color="primary"
          outline={isActive}
          onClick={!isActive ? handleBind : handleUnbind}
        >
          {!isActive 
            ? intl.formatMessage({ id: "app.home.contact" })
            : intl.formatMessage({ id: "app.home.disconnect" })
          }
        </Button>
      </div>
    </SocialCard>
  );
}
